import React from 'react';
import { Clock, Settings, Heart } from 'lucide-react';
import { triggerHapticFeedback } from '../../utils/capacitorHelper';

const BottomNavigation = ({ activeTab, onTabChange }) => {
  const handleTabPress = (id) => {
    if (id === activeTab) return;
    triggerHapticFeedback('light');
    onTabChange(id);
  };

  const tabs = [
    { id: 'home', label: 'Home', icon: 'logo' },
    { id: 'favorites', label: 'Favorites', icon: Heart },
    { id: 'rides', label: 'History', icon: Clock },
    { id: 'account', label: 'Settings', icon: Settings }
  ];

  return (
    <div
      data-testid="rider-bottom-nav"
      className="fixed bottom-4 left-4 right-4 z-50"
      style={{ paddingBottom: 'env(safe-area-inset-bottom, 0)' }}
    >
      {/* Clear glassy container — transparent with a wet, shiny reflection (no fog/blur) */}
      <div
        className="relative rounded-3xl border border-white/50 shadow-[0_12px_40px_-8px_rgba(16,185,129,0.25),0_2px_6px_rgba(0,0,0,0.05)] overflow-hidden"
        style={{
          background: 'linear-gradient(135deg, rgba(255,255,255,0.90) 0%, rgba(255,255,255,0.75) 42%, rgba(255,255,255,0.83) 100%)',
        }}
      >
        {/* Subtle inner highlight (top edge) for a glassy edge */}
        <div
          aria-hidden="true"
          className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-white/80 to-transparent"
        />
        {/* Specular shine — soft diagonal reflection for the wet/water look */}
        <div
          aria-hidden="true"
          className="pointer-events-none absolute -top-6 -left-8 w-2/3 h-16 rotate-12 rounded-full"
          style={{ background: 'radial-gradient(closest-side, rgba(255,255,255,0.45), rgba(255,255,255,0))' }}
        />
        <div className="flex items-center justify-around h-16 px-1">
          {tabs.map((tab) => {
            const isActive = activeTab === tab.id;
            return (
              <button
                key={tab.id}
                onClick={() => handleTabPress(tab.id)}
                data-testid={`rider-tab-${tab.id}`}
                className="flex flex-col items-center justify-center flex-1 h-full transition-all duration-200 active:scale-95"
              >
                <div
                  className={`relative flex flex-col items-center justify-center w-14 h-11 rounded-2xl transition-all duration-300 ${
                    isActive
                      ? 'bg-emerald-500/15 ring-1 ring-emerald-500/35 shadow-[0_0_18px_-4px_rgba(16,185,129,0.55)]'
                      : ''
                  }`}
                >
                  {tab.icon === 'logo' ? (
                    <div className={`w-7 h-7 rounded-lg overflow-hidden mb-0.5 transition-transform ${isActive ? 'scale-105' : ''}`}>
                      <img
                        src="https://customer-assets.emergentagent.com/job_yachangu-pay/artifacts/ynseryay_EE6C3FEA-5C5E-424A-B08C-ED1F2A53B790.jpeg"
                        alt="Yachangu"
                        className="w-full h-full object-cover"
                      />
                    </div>
                  ) : (
                    React.createElement(tab.icon, {
                      className: `w-[22px] h-[22px] mb-0.5 transition-colors ${
                        isActive ? 'text-emerald-700 stroke-[2.4]' : 'text-gray-500'
                      }`,
                    })
                  )}
                  <span
                    className={`text-[10px] tracking-tight transition-colors ${
                      isActive ? 'font-semibold text-emerald-800' : 'font-medium text-gray-500'
                    }`}
                  >
                    {tab.label}
                  </span>
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default BottomNavigation;
